import { render, staticRenderFns } from "./EcommerceTransactionsHistory.vue?vue&type=template&id=38d7144d&"
import script from "./EcommerceTransactionsHistory.vue?vue&type=script&lang=js&"
export * from "./EcommerceTransactionsHistory.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTransactionsHistory.vue?vue&type=style&index=0&id=38d7144d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports